// Copyright (c) 2023-present VexFlow contributors: https://github.com/vexflow/vexflow/graphs/contributors
// @author Balazs Forian-Szabo
// MIT License
import { Element } from './element';
import { Category } from './typeguard';
import { log } from './util';
import { Vibrato } from './vibrato';
// eslint-disable-next-line
function L(...args) {
    if (VibratoBracket.DEBUG)
        log('Vex.Flow.VibratoBracket', args);
}
/** `VibratoBracket` renders vibrato effect between two notes. */
class VibratoBracket extends Element {
    static get CATEGORY() {
        return Category.VibratoBracket;
    }
    /**
     * Either the stop or start note must be set, or both of them.
     * An undefined value for the start or stop note indicates that the vibrato
     * is drawn from the beginning or until the end of the stave accordingly.
     */
    constructor(bracketData) {
        super();
        if (bracketData.start)
            this.start = bracketData.start;
        if (bracketData.stop)
            this.stop = bracketData.stop;
        this.line = 1;
        this.renderOptions = {
            harsh: false,
            waveHeight: 6,
            waveWidth: 4,
            waveGirth: 2,
            vibratoWidth: 0,
        };
    }
    /** Set line position of the vibrato bracket. */
    setLine(line) {
        this.line = line;
        return this;
    }
    /** Set harsh vibrato bracket. */
    setHarsh(harsh) {
        this.renderOptions.harsh = harsh;
        return this;
    }
    /** Draw the vibrato bracket on the rendering context. */
    draw() {
        const ctx = this.checkContext();
        this.setRendered();
        const y = (this.start && this.start.checkStave().getYForTopText(this.line)) ||
            (this.stop && this.stop.checkStave().getYForTopText(this.line)) ||
            0;
        // If start note is not set then vibrato will be drawn
        // from the beginning of the stave
        const startX = (this.start && this.start.getAbsoluteX()) || (this.stop && this.stop.checkStave().getTieStartX()) || 0;
        // If stop note is not set then vibrato will be drawn
        // until the end of the stave
        const stopX = (this.stop && this.stop.getAbsoluteX() - this.stop.getWidth() - 5) ||
            (this.start && this.start.checkStave().getTieEndX() - 10) ||
            0;
        this.renderOptions.vibratoWidth = stopX - startX;
        L('Rendering VibratoBracket: startX:', startX, 'stopX:', stopX, 'y:', y);
        Vibrato.renderVibrato(ctx, startX, y, this.renderOptions);
    }
}
/** To enable logging for this class. Set `Vex.Flow.VibratoBracket.DEBUG` to `true`. */
VibratoBracket.DEBUG = false;
export { VibratoBracket };
